import React, { useState } from 'react';
import config from '../../config/config';
import { t } from '../../util/messages';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '..';
import css from './PrivacyPolicyPage.module.css';

const PrivacyPolicyPage = () => {
  const [scrollingDisabled, setScrollingDisabled] = useState(false);

  const onManageDisableScrolling = (_id, disabled = false) => {
    setScrollingDisabled(disabled);
  };

  const schemaTitle = t('PrivacyPolicyPage.title', { siteTitle: config.siteTitle });
  const schemaDescription = t('PrivacyPolicyPage.schemaDescription');


  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      description={schemaDescription}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
        url: `${config.canonicalRootURL}/privacy-policy`,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer onManageDisableScrolling={onManageDisableScrolling} />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.content}>
              <article className={css.legalContainer}>
                <h1>Privacy Policy</h1>
                <p className={css.lastUpdated}>Last Updated: October 15, 2026</p>
                <p>
                  Gitribe values your privacy and is committed to protecting your personal
                  information. This Privacy Policy explains how we collect, use, disclose,
                  and safeguard personal data.
                </p>

                <h2>Data Controller</h2>
                <p>
                  Gitribe is the data controller responsible for processing personal data
                  collected through this Website.
                </p>

                <h2>Information We Collect</h2>
                <ul>
                  <li>Name, email address, and phone number</li>
                  <li>Information submitted via contact or inquiry forms</li>
                  <li>IP address, browser type, and device information</li>
                  <li>Usage and analytics data</li>
                </ul>

                <h2>Purpose of Processing</h2>
                <p>We process personal data to:</p>
                <ul>
                  <li>Respond to inquiries and business requests</li>
                  <li>Provide information about our services</li>
                  <li>Improve Website functionality and performance</li>
                  <li>Ensure security and prevent misuse</li>
                  <li>Send marketing communications with consent</li>
                </ul>

                <h2>Legal Basis for Processing</h2>
                <p>
                  Personal data is processed based on consent, contractual necessity,
                  legitimate business interests, and compliance with legal obligations,
                  where applicable.
                </p>

                <h2>Data Retention</h2>
                <p>
                  Personal data is retained only for as long as necessary to fulfill the
                  purposes for which it was collected or to meet legal and business
                  requirements.
                </p>

                <h2>Your Rights</h2>
                <p>Subject to applicable laws, you may have the right to:</p>
                <ul>
                  <li>Access your personal data</li>
                  <li>Request correction or deletion</li>
                  <li>Restrict or object to processing</li>
                  <li>Withdraw consent at any time</li>
                  <li>Request a copy of your data</li>
                </ul>

                <h2>Data Sharing</h2>
                <p>
                  We do not sell personal data. Information may be shared with trusted
                  service providers who assist in operating the Website and delivering
                  services, under confidentiality obligations.
                </p>

                <h2>Cookies</h2>
                <p>
                  We use cookies to enhance user experience, analyze traffic, and improve
                  website performance. Cookies do not directly identify individuals and
                  can be managed through browser settings.
                </p>

                <h2>Live Chat</h2>
                <p>
                  The Website offers a live chat powered by Tawk.to. If you start a
                  chat, the messages you send, any name or email address you provide,
                  your approximate location and technical details such as your browser
                  and the pages you viewed are processed by Tawk.to on our behalf so we
                  can reply to you. The chat sets cookies to keep your conversation
                  together. You can end a chat at any time and do not need to use it to
                  use the Website.
                </p>

                <h2>Data Security</h2>
                <p>
                  We apply appropriate technical and organizational measures to protect
                  personal data against unauthorized access, disclosure, or loss.
                </p>

                <h2>Data Transfers</h2>
                <p>
                  Personal data may be processed or stored where we or our service
                  providers operate. Appropriate safeguards are applied in accordance
                  with applicable data protection laws.
                </p>

                <h2>Changes to This Policy</h2>
                <p>
                  This Privacy Policy may be updated from time to time. Any changes will
                  be posted on this page with the revised effective date.
                </p>

                <h2>Contact</h2>
                <p>
                  For questions or concerns regarding this Privacy Policy, please contact
                  us at{' '}
                  <a href="mailto:contact@gitribe.com">contact@gitribe.com</a>.
                </p>
              </article>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <div className={css.footerContainer}>
            <Footer />
          </div>
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

export default PrivacyPolicyPage;
